import React, { PureComponent } from 'react';
import UserInfo from '@ifeng-fe/ui_pc_userInfo';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

class Header extends PureComponent {
    render() {
        return (
            <div className={styles.commentHeader}>
                <div className={styles.commentHeaderInner}>
                    <div className={styles.wRightBar}>
                        <div className={styles.backPage}>
                            <a className={styles.wa} href="//www.ifeng.com" target="_blank">
                                凤凰网首页
                            </a>
                            <em>|</em>
                        </div>
                        <div className={styles.userInfoBox}>
                            <UserInfo option={['login', 'register']} />
                        </div>
                    </div>
                    <div className={styles.wBanner}>凤凰评论</div>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Header);
